import { Injectable, inject } from '@angular/core';
import { Tooth } from '@modules/teeth-diagram/models/tooth';
import { BRIDGE_VALIDATION_ERRORS } from '../models/consts';
import { IntuitiveBridge, IntuitiveBridgeValidationErrors } from '../models/intuitive-bridge';
import { RxIntuitiveBridgeService } from './rx-intuitive-bridge-service';
import { RxIntuitiveIndicationMapperService } from '@modules/rx-intuitive-teeth-orchestrator/services/rx-intuitive-indication-mapper.service';

@Injectable()
export class RxIntuitiveBridgeValidationService {
	private readonly bridgeService = inject(RxIntuitiveBridgeService);
	private readonly indicationMapper = inject(RxIntuitiveIndicationMapperService);

	isDefaultBridgeIndication(tooth: Tooth): boolean {
		const indication = this.indicationMapper.getBridgeIndicationForDiagram(tooth);

		return this.indicationMapper.isDefaultIndication(indication);
	}

	validateBridge(bridge: IntuitiveBridge): IntuitiveBridgeValidationErrors {
		const result: IntuitiveBridgeValidationErrors = {
			teeth: {},
			summary: []
		};

		if (!this.bridgeService.canSaveBridgeTeeth(bridge)) {
			result.summary.push(BRIDGE_VALIDATION_ERRORS.invalidSpanWarning);
		}

		bridge.teeth.forEach(t => {
			if (t.ToothID != null && this.isDefaultBridgeIndication(t)) {
				result.teeth[t.ToothID] = [BRIDGE_VALIDATION_ERRORS.regularWarning];
				result.summary.push(BRIDGE_VALIDATION_ERRORS.regularWarning);
			}
		});

		return result;
	}
}
